export interface NavLink {
  id: string;
  label: string;
}

export const navLinks: NavLink[] = [
  { id: "skills", label: "恋爱技巧" },
  { id: "dating", label: "约会攻略" },
  { id: "topics", label: "两性话题" },
  { id: "consult", label: "情感咨询" },
  { id: "stories", label: "爱情故事" },
  { id: "articles", label: "情感文章" },
];

export const heroTags: string[] = ["恋爱技巧", "约会攻略", "两性话题", "情感咨询", "爱情故事"];

export const categories: string[] = ["全部", "恋爱技巧", "约会攻略", "两性话题", "情感咨询", "爱情故事"];

export interface Skill {
  title: string;
  desc: string;
  points: string[];
}

export const skills: Skill[] = [
  {
    title: "识别心动的三个阶段",
    desc: "心动不是一瞬间的事。好感来自外在吸引，吸引来自相处时的舒适，依恋来自长期的可靠回应。看清自己处在哪个阶段，就不会用错方式，也不会因为对方回应慢一点就慌乱。",
    points: ["好感期：多制造自然接触", "吸引期：展示真实的生活", "依恋期：用稳定的回应积累信任"],
  },
  {
    title: "先接情绪，再谈事情",
    desc: "很多争吵不是因为事情本身，而是因为情绪没被接住。对方抱怨工作很累，第一句别说「那就早点睡」，而先说「今天是不是特别辛苦」。情绪被看见之后，道理才听得进去。",
    points: ["复述对方的感受", "不急着给解决方案", "先确认对方想不想听建议"],
  },
  {
    title: "表达喜欢的四个分寸",
    desc: "喜欢要说出口，但不必一次说完。分寸感不是冷淡，而是给对方留出回应的空间，也给自己留出观察的时间。真诚的表达，往往比刻意的试探更有力量。",
    points: ["用具体细节代替空泛夸奖", "主动但不纠缠", "把邀约说成邀请，而非考核", "接受对方需要时间"],
  },
  {
    title: "建立安全感的三件小事",
    desc: "安全感很少来自誓言，更多来自可预期的小事：说到做到、主动报备不消失、在对方需要时在场。这些事看起来普通，却是关系最结实的底座。",
    points: ["承诺要小，兑现要快", "重要安排提前说一声", "情绪低谷时先陪着"],
  },
  {
    title: "把分歧变成并肩",
    desc: "吵架的目标不是赢，而是解决问题。把「你怎么总是这样」换成「我们好像遇到一个问题」，立场就从对立变成了同一队。",
    points: ["只谈当下这一件事", "说需求，而不是指责", "约定一个暂停的信号"],
  },
  {
    title: "保持边界，不讨好也不控制",
    desc: "健康的关系里，两个人都保留自己的生活。讨好会让你越来越累，控制会让对方越来越远；清楚说出自己的底线，反而让相处更轻松。",
    points: ["保留自己的朋友和爱好", "明确不能接受的行为", "边界要提前说，而不是爆发时算账"],
  },
];

export interface DatingPoint {
  t: string;
  d: string;
}

export interface DatingStep {
  label: string;
  subtitle: string;
  points: DatingPoint[];
}

export const datingSteps: DatingStep[] = [
  {
    label: "约会前",
    subtitle: "准备阶段",
    points: [
      {
        t: "确定一个轻松的场合",
        d: "第一次见面优先选安静、可交谈、能自由离开的地方，比如咖啡馆或公园，避免过于正式或时间过长的安排。",
      },
      {
        t: "准备三个开放式话题",
        d: "最近让你开心的小事、彼此的兴趣爱好、接下来想尝试的新鲜事，能让对话自然流动，避免冷场。",
      },
      {
        t: "穿着以自己舒适为准",
        d: "整洁、合身、符合场合即可，不必为了迎合对方改变风格，真实的你更值得被喜欢。",
      },
    ],
  },
  {
    label: "见面时",
    subtitle: "相处阶段",
    points: [
      {
        t: "用倾听代替表演",
        d: "多问一句「后来呢」，把注意力放在对方身上，比不停展示自己更容易拉近距离。",
      },
      {
        t: "留意细节而非打分",
        d: "观察对方如何对待服务员、是否准时、有没有尊重你的边界，这些细节比外表更能说明问题。",
      },
      {
        t: "允许沉默存在",
        d: "短暂的安静不等于失败，自然地喝口水、看看窗外，反而让相处更放松。",
      },
    ],
  },
  {
    label: "约会尾声",
    subtitle: "收尾阶段",
    points: [
      {
        t: "真诚表达这次的感受",
        d: "可以直接说「今天聊得挺开心」，把感受说清楚，不必用欲擒故纵去试探对方。",
      },
      {
        t: "尊重节奏，不强求下次",
        d: "如果合适，可以约下一次；如果不确定，也可以说需要再想想，诚实比套路更长久。",
      },
      {
        t: "安全永远第一",
        d: "把握好自己的行程安排，初次见面尽量选择公共场所，让信任的家人或朋友知道你的去向。",
      },
    ],
  },
  {
    label: "约会之后",
    subtitle: "跟进阶段",
    points: [
      {
        t: "当天或次日给一句反馈",
        d: "简单的一句「到家了吗」或「今天很开心」，既是礼貌，也给关系一个温和的继续。",
      },
      {
        t: "观察回应的节奏",
        d: "不必数着分钟等消息，但可以留意对方是否愿意持续交流，稳定的回应比热烈的开场更重要。",
      },
      {
        t: "保持自己的生活",
        d: "约会只是生活的一部分，继续运动、学习、陪伴朋友，让你本身就是一个有吸引力的人。",
      },
    ],
  },
];

export interface Topic {
  q: string;
  a: string;
  b: string;
  note: string;
}

export const topics: Topic[] = [
  {
    q: "暧昧期到底要不要主动？",
    a: "主动派：喜欢就应该让对方知道，坦诚比猜来猜去更省时间，也可能让关系更快明朗。",
    b: "克制派：适度保留可以避免一头热，也给自己观察对方是否真心投入的机会。",
    note: "可以这样想：主动和纠缠的区别，在于你是否尊重对方的回应。表达好感、给出机会，然后看对方如何接住，这就是刚刚好的主动。",
  },
  {
    q: "恋爱中该不该看对方手机？",
    a: "透明派：彼此坦荡就没什么不能看，愿意公开也是一种信任的证明。",
    b: "隐私派：每个人都需要自己的空间，翻看手机往往源于不安，解决不安比查看记录更重要。",
    note: "可以这样想：真正让关系安全的是沟通，而不是监控。与其查证，不如直接说出「我最近有点不安」，把不安交给对方一起面对。",
  },
  {
    q: "异地恋怎样才能坚持下去？",
    a: "规律联系：固定时间通话、分享日常，让彼此参与对方的生活，减少距离带来的疏离。",
    b: "共同目标：约定下一次见面的时间，规划未来如何结束异地，方向感是最好的黏合剂。",
    note: "可以这样想：距离本身不会拆散关系，失去参与感才会。让重要的事第一时间想让对方知道，异地也能很踏实。",
  },
  {
    q: "约会到底该由谁来买单？",
    a: "轮流请：你请这次、我请下次，既有心意，也不给任何一方压力。",
    b: "各付各的：彼此平等、互不亏欠，适合刚认识、关系还没确定的时候。",
    note: "可以这样想：方式没有对错，关键是两个人都舒服。可以提前自然地说一句「这顿我来，下次换你」，把付款变成默契而不是考验。",
  },
];

export interface Consult {
  q: string;
  a: string;
}

export const consults: Consult[] = [
  {
    q: "我总是秒回对方消息，会不会显得太主动？",
    a: "秒回本身不是问题，问题在于你是否因此患得患失。如果你回得快，也过得充实，那只是你习惯及时回应；但如果你盯着屏幕等回复、不敢做别的事，那要调整的是自己的生活重心。试着把注意力放回手头的事，回复依然真诚，但不再把对方的节奏当成情绪开关。",
  },
  {
    q: "对方忽冷忽热，我该怎么办？",
    a: "先别急着把一切归因于自己。忽冷忽热有很多可能：他正在忙、情绪起伏，或者对关系的态度还不确定。你可以直接而温和地表达感受：「最近我们的联系好像淡了一些，我会有点不安，你怎么看？」看对方如何回应，比反复猜测更有效。如果长期只有你在主动，也要允许自己认真考虑这段关系的去留。",
  },
  {
    q: "表白被拒绝后，还能做朋友吗？",
    a: "能，但要给彼此时间。被拒绝后立刻做朋友，往往是你舍不得放下的借口。可以先拉开距离，把精力放回自己身上，等情绪真正平静了，再决定要不要以朋友的身份继续相处。如果见面还是会难受，选择体面地退场，也是对彼此的尊重。",
  },
  {
    q: "吵架之后，应该谁先低头？",
    a: "谁先低头不重要，谁先愿意解决问题才重要。可以先降温，等情绪过去再谈；开口时用「我」开头，比如「我刚才有点着急，我们重新聊聊好吗」，比「你先道歉」更容易让对方放下戒备。真正的输赢，是把一件事解决掉，而不是把对方说服。",
  },
  {
    q: "怎样判断一段关系值不值得继续？",
    a: "看三件事：你在关系里是被滋养还是被消耗；你们能不能好好沟通、一起解决问题；未来是否有一个两个人都愿意努力的方向。如果长期只有你一个人在付出、沟通总是无效、想到未来全是疲惫，那就值得认真考虑。好的关系不完美，但会让你更安心，而不是更焦虑。",
  },
  {
    q: "谈恋爱会不会影响学习和工作？",
    a: "会，但方向和程度取决于你怎么经营。被情绪牵着走确实会分心；但如果关系稳定、彼此支持，它也能成为你努力的动力。关键是保留自己的节奏：重要的任务照常完成，把恋爱放进生活，而不是让恋爱占满生活。",
  },
];

export interface Story {
  title: string;
  tag: string;
  excerpt: string;
  takeaway: string;
  img: string;
  alt: string;
}

export const stories: Story[] = [
  {
    title: "咖啡店里的一下午",
    tag: "初识",
    excerpt:
      "他们在同一排书架前同时伸手，拿的是同一本书。她先笑了，于是两个人从书聊到生活，又在门口的咖啡店坐了一下午，直到店家准备打烊。",
    takeaway: "有时候缘分只差一句自然的开口。",
    img: "https://readdy.ai/api/search-image?query=Cozy%20warm%20cafe%20interior%20with%20two%20coffee%20cups%20on%20a%20wooden%20table%20near%20a%20sunlit%20window%2C%20stylized%20painterly%20editorial%20style%2C%20cream%20coral%20and%20amber%20palette%2C%20soft%20blurred%20background%2C%20romantic%20intimate%20atmosphere%2C%20gentle%20morning%20light%2C%20delicate%20grain%20texture%2C%20minimal%20composition%20with%20generous%20negative%20space%2C%20harmonious%20warm%20tones&width=800&height=600&seq=loveisland-story-01&orientation=landscape",
    alt: "温暖的咖啡馆里两只咖啡杯摆在木桌上",
  },
  {
    title: "那把被递过来的伞",
    tag: "互相照顾",
    excerpt:
      "下班时突然下雨，她把伞递给他，自己转身跑向地铁。后来他每天都「顺路」多带一把伞，直到他们不再是顺路的两个人。",
    takeaway: "好感常常藏在不动声色的关心里。",
    img: "https://readdy.ai/api/search-image?query=Two%20figures%20sharing%20a%20single%20umbrella%20walking%20on%20a%20quiet%20rainy%20street%20at%20dusk%2C%20stylized%20painterly%20illustration%2C%20warm%20coral%20and%20amber%20reflections%20on%20wet%20pavement%2C%20soft%20bokeh%20background%2C%20romantic%20gentle%20mood%2C%20dreamy%20atmosphere%2C%20subtle%20grain%20texture%2C%20minimal%20composition%20with%20negative%20space%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=800&height=600&seq=loveisland-story-02&orientation=landscape",
    alt: "黄昏细雨里两个人共撑一把伞走在街上",
  },
  {
    title: "一起做饭的周末",
    tag: "日常陪伴",
    excerpt:
      "他们约定每个周末一起做一顿饭。有人切菜、有人掌勺，油烟和笑声混在一起。平淡的日子里，他们慢慢把「我」过成了「我们」。",
    takeaway: "长期关系靠的不是惊喜，而是愿意一起重复的日常。",
    img: "https://readdy.ai/api/search-image?query=Couple%20cooking%20together%20in%20a%20bright%20warm%20home%20kitchen%2C%20hands%20preparing%20fresh%20vegetables%20on%20a%20wooden%20counter%2C%20stylized%20painterly%20editorial%20style%2C%20cream%20coral%20and%20sage%20green%20palette%2C%20soft%20natural%20window%20light%2C%20blurred%20cozy%20background%2C%20warm%20intimate%20domestic%20mood%2C%20delicate%20grain%2C%20harmonious%20composition&width=800&height=600&seq=loveisland-story-03&orientation=landscape",
    alt: "明亮温馨的厨房里两人一起做饭切菜",
  },
  {
    title: "黄昏的海边散步",
    tag: "长久",
    excerpt:
      "相处很多年后，他们依旧保留着散步的习惯。海边的风把话说得很慢，他们把年轻时的争吵，都熬成了此刻的默契。",
    takeaway: "陪伴到最后，是最朴素也最难得的浪漫。",
    img: "https://readdy.ai/api/search-image?query=Two%20silhouettes%20walking%20along%20a%20calm%20beach%20at%20golden%20hour%2C%20gentle%20waves%20and%20warm%20amber%20sky%2C%20stylized%20painterly%20illustration%2C%20coral%20gold%20and%20cream%20palette%2C%20soft%20dreamy%20atmosphere%2C%20blurred%20horizon%2C%20romantic%20peaceful%20mood%2C%20subtle%20grain%20texture%2C%20minimal%20composition%2C%20high%20detail%2C%20harmonious%20warm%20tones&width=800&height=600&seq=loveisland-story-04&orientation=landscape",
    alt: "金色黄昏下两个人的剪影沿海边散步",
  },
];

export interface Stage {
  key: string;
  label: string;
  situation: string;
  actions: string[];
  worry: string;
  advice: string;
}

export const stages: Stage[] = [
  {
    key: "single",
    label: "单身期",
    situation: "还没遇到合适的人，或者刚从一段关系里走出来。",
    actions: ["把生活过好，也扩展自己的圈子", "想清楚自己真正想要什么样的相处", "先和自己和解，不急着填补空白"],
    worry: "担心一直遇不到对的人。",
    advice: "与其焦虑等待，不如让自己成为一个有趣、稳定、值得靠近的人，好的关系往往从好的状态开始。",
  },
  {
    key: "ambiguous",
    label: "暧昧期",
    situation: "彼此有好感，但关系还没有挑明。",
    actions: ["保持真诚的互动，不做过度试探", "给对方也能靠近你的机会", "观察回应是否稳定，而不只看一时热烈"],
    worry: "不确定对方是不是真心。",
    advice: "可以适度主动，然后留出空间，看对方如何接住。真正的在乎，会体现在持续的回应里。",
  },
  {
    key: "passion",
    label: "热恋期",
    situation: "关系升温，恨不得每天都黏在一起。",
    actions: ["享受甜蜜，也保留各自的节奏", "别急着把全部生活交出去", "在热情里保持基本的边界"],
    worry: "害怕热度过去，感情就变淡了。",
    advice: "热恋的浓度会回落是正常的。能留下来的，是相处舒服、愿意一起生活的两个人。",
  },
  {
    key: "stable",
    label: "稳定期",
    situation: "关系进入日常，激情慢慢变成了陪伴。",
    actions: ["用小惊喜和仪式感维持温度", "一起规划未来，也尊重彼此的差异", "定期好好聊一次彼此的近况"],
    worry: "感觉太平淡，像少了点什么。",
    advice: "平淡不是不爱，而是关系有了安全感。定期一起做点新鲜事，就能让稳定不等于无聊。",
  },
  {
    key: "repair",
    label: "修复期",
    situation: "刚刚经历了争吵、冷战，或一次信任危机。",
    actions: ["先降温，再沟通，不翻旧账", "说清自己的需求和感受", "必要时寻求专业的情感咨询"],
    worry: "不知道还能不能回到从前。",
    advice: "修复不是回到过去，而是重新建立一个更懂彼此的关系。愿意一起面对，就已经赢了一半。",
  },
];

export interface Article {
  title: string;
  category: string;
  summary: string;
  read: string;
}

export const articles: Article[] = [
  { title: "心动之后，先别急着确定关系", category: "恋爱技巧", summary: "给关系一点观察期，看清对方在细节里如何待人处事。", read: "6 分钟" },
  { title: "把「你总是」换成「我希望」", category: "恋爱技巧", summary: "同样一件事，换一种表达，争吵可能就变成了一次靠近。", read: "5 分钟" },
  { title: "如何回应一句迟到的消息", category: "恋爱技巧", summary: "不生气、不冷处理，同时把自己的感受说清楚。", read: "4 分钟" },
  { title: "第一次约会别踩的五个坑", category: "约会攻略", summary: "地点、话题、时间和告别方式，都会影响你们的下一步。", read: "7 分钟" },
  { title: "约会聊什么，才不会冷场", category: "约会攻略", summary: "把问答变成分享，让对话自然流动的三个小技巧。", read: "5 分钟" },
  { title: "从线上聊天到线下见面的过渡", category: "约会攻略", summary: "从屏幕到现实，节奏和分寸比话术更重要。", read: "5 分钟" },
  { title: "买单这件事，AA 还是轮流请", category: "两性话题", summary: "关于付款，两个人舒服才是最好的答案。", read: "4 分钟" },
  { title: "恋爱里的隐私边界该怎么划", category: "两性话题", summary: "透明与空间并不矛盾，关键是彼此信任。", read: "6 分钟" },
  { title: "对方忽冷忽热的三个可能", category: "情感咨询", summary: "先别急着自我怀疑，看清原因再决定怎么回应。", read: "6 分钟" },
  { title: "分手之后，要不要做朋友", category: "情感咨询", summary: "给自己一点时间，答案会慢慢清晰。", read: "5 分钟" },
  { title: "他们从一把伞开始", category: "爱情故事", summary: "不动声色的照顾，是最踏实的喜欢。", read: "4 分钟" },
  { title: "一起做饭的第三百个周末", category: "爱情故事", summary: "把「我」过成「我们」，靠的是一天天的相处。", read: "4 分钟" },
];

export interface ValueItem {
  icon: string;
  title: string;
  desc: string;
}

export const values: ValueItem[] = [
  {
    icon: "ri-heart-3-line",
    title: "具体，不空谈",
    desc: "每一篇都尽量给出可以照着做的做法，而不是只停留在「要真诚」「要沟通」这样的口号上。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重，不评判",
    desc: "不贴标签、不站队。关系里的选择因人而异，我们更愿意帮你看清选项，而不是替你下结论。",
  },
  {
    icon: "ri-compass-3-line",
    title: "同行，不催促",
    desc: "无论你正在追求、热恋，还是感到困惑，都可以按自己的节奏翻阅，慢慢找到适合你的答案。",
  },
];